import styled from 'styled-components'

import { Footer } from '@/components/elements/footer/Footer'
import { Header } from '@/components/elements/header/Header'
import { GutShotBenefitsList } from '@/components/pages/gutshot/GutShotBenefitsList'
import { GutShotGetStartedSection } from '@/components/pages/gutshot/GutShotGetStartedSection'
import { GutShotGuideSection } from '@/components/pages/gutshot/GutShotGuideSection'
import { GutShotPageHeroSection } from '@/components/pages/gutshot/GutShotPageHeroSection'
import { GutShotScienceSection } from '@/components/pages/gutshot/GutShotScienceSection'
import { GutShotVideoSection } from '@/components/pages/gutshot/GutShotVideoSection'
import { GutShotWhatIsZoeSection } from '@/components/pages/gutshot/GutShotWhatIsZoeSection'

const StyledGutShotPage = styled.main`
  background-color: ${(props) => props.theme.v2.surface.cream100};
  padding: 20px;
`

const StyledSeparator = styled.div`
  display: block;
  height: 96px;

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    height: 48px;
  }
`

export const GutShotGuideContent = () => {
  return (
    <>
      <StyledGutShotPage>
        <Header />
        <GutShotPageHeroSection />
        <StyledSeparator />
        <GutShotGuideSection />
        <StyledSeparator />
        <GutShotBenefitsList />
        <StyledSeparator />
        <GutShotGetStartedSection />
        <StyledSeparator />
        <GutShotVideoSection />
        <StyledSeparator />
        <GutShotScienceSection />
        <StyledSeparator />
        <GutShotWhatIsZoeSection />
        <StyledSeparator />
        <GutShotGetStartedSection />
        <StyledSeparator />
        <Footer />
      </StyledGutShotPage>
    </>
  )
}
